export default __webpack_public_path__ + "15fac6a.png";